const Card = {
  baseStyle: {
    p: { base: "12px 10px", sm: "16px 12px", md: "20px 18px" },
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    minWidth: "0px",
    wordWrap: "break-word",
    backgroundClip: "border-box",
    transition: "all 0.25s ease-in-out",
  },
  variants: {
    panel: (props) => ({
      bg: props.colorMode === "dark" ? "navy.700" : "white",
      width: "100%",
      boxShadow: props.colorMode === "dark" 
        ? "0px 10px 30px rgba(0, 0, 0, 0.35), inset 0px 1px 0px rgba(255, 255, 255, 0.05)" 
        : "0px 10px 25px rgba(148, 163, 184, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.04)",
      borderRadius: { base: "14px", sm: "16px", md: "20px" },
      border: props.colorMode === "dark" ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(226, 232, 240, 0.8)",
    }),
  },
  defaultProps: {
    variant: "panel",
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};

